module.exports = "<p>\n  attraction-add-dialog works!\n</p>\n"